export const HEATMAP_METRICS = ['overall', 'price', 'co2', 'ppm'] as const;
export type HeatmapMetric = (typeof HEATMAP_METRICS)[number];